
import { mail_img, nav_img } from "@assets/images";
import { hfw_logo } from "@assets/svg";
import { NavLink, useNavigate } from "@remix-run/react";
import { classNames } from "@utilities";

export default function FooterMobile({ footerCopyright }: { footerCopyright: boolean }) {
    const navigate = useNavigate();

    const handleLogoClick = () => {
        localStorage.setItem("position", "footer");
        navigate("/")
    }

    return (
        <div className="loader-opacity-footer-mobile px-8 py-10 mb-10 items-start container divide-y border-t border-[#E9DDFF]">
            <div className="flex flex-col gap-y-4 pb-4">
                <div className={classNames("flex flex-col", footerCopyright ? "gap-y-4" : " gap-y-6")}>
                    <button onClick={handleLogoClick}>
                        <img src={hfw_logo} alt="brand_logo" className="w-28 h-full" />
                    </button>
                    <p className={classNames("text-[#667085] font-normal", footerCopyright ? "text-xs" : " text-base")}> Equip yourself with tools for long-term growth of your business </p>
                </div>

                <div className="flex flex-col gap-y-4">
                    <div className="flex gap-x-2">
                        <img src={nav_img} className="w-5 h-5" alt="address" />
                        <p className="text-[#625B70] text-xs font-normal"> Hiranandani Estate, Thane - 400607 </p>
                    </div>
                    <div className="flex gap-x-2">
                        <img src={mail_img} className="w-5 h-5" alt="email" />
                        <p className="text-[#625B70] text-xs font-normal"> help@howframeworks.com </p>
                    </div>
                </div>

                <div className="flex flex-wrap items-start gap-x-[20px] gap-y-[8px] self-stretch">
                    <NavLink
                        to="/affiliate"
                        className="text-[#625B70] font-medium text-[12px] underline decoration-solid"
                        onClick={() => localStorage.setItem("position", "footer")}
                    >
                        Become an Affiliate
                    </NavLink>
                    {/* <NavLink
                        to="/blogs"
                        className="text-[#625B70] font-medium text-[12px] underline decoration-solid"
                    >
                        Blog
                    </NavLink> */}
                    <NavLink
                        to="/terms"
                        className="text-[#625B70] font-medium text-[12px] underline decoration-solid"
                    >
                        Terms
                    </NavLink>
                    <NavLink
                        to="/privacy"
                        className="text-[#625B70] font-medium text-[12px] underline decoration-solid"
                    >
                        Privacy
                    </NavLink>
                    <NavLink
                        to="/refund"
                        className="text-[#625B70] font-medium text-[12px] underline decoration-solid"
                    >
                        Refund
                    </NavLink>
                </div>

                {/* {
                    footerCopyright ?
                        <div className="flex flex-col gap-y-4">
                            <div className="flex gap-x-2">
                                <img src={nav_img} className="w-5 h-5" alt="address" />
                                <p className="text-[#625B70] text-xs font-normal"> Hiranandani Estate, Thane - 400607 </p>
                            </div>
                            <div className="flex gap-x-2">
                                <img src={mail_img} className="w-5 h-5" alt="email" />
                                <p className="text-[#625B70] text-xs font-normal"> help@howframeworks.com </p>
                            </div>
                        </div>
                        : ""
                } */}
            </div>
            {
                footerCopyright ?
                    <div className="pt-4">
                        <p className="text-[#625B70] text-xs font-normal">Copyright © Mittelstand Business Solutions Private Limited. All rights reserved <br /><br /> CIN: U70200MH2023PTC404788 </p>
                    </div>
                    :
                    <div></div>
            }
        </div>
    )
}
